import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=7e25fb98&scoped=true&"
import script from "./order-list.js?vue&type=script&lang=js&"
export * from "./order-list.js?vue&type=script&lang=js&"
import style0 from "./order-list.css?vue&type=style&index=0&id=7e25fb98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e25fb98",
  null
  
)

export default component.exports